var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 33,
    viewBox: "0 0 31 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7956 8.89062H5.9246C4.82715 8.89062 3.9375 9.78028 3.9375 10.8777V13.5272C3.9375 14.6246 4.82716 15.5143 5.9246 15.5143H9.89879H21.8214H25.7956C26.893 15.5143 27.7827 14.6246 27.7827 13.5272V10.8777C27.7827 9.78028 26.893 8.89062 25.7956 8.89062Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8604 6.90362C15.8604 5.07455 17.3431 3.5918 19.1722 3.5918H19.8345C21.2978 3.5918 22.484 4.778 22.484 6.24126V6.24126C22.484 7.70452 21.2978 8.89072 19.8345 8.89072H15.8604V6.90362Z",
    stroke: "currentColor",
    strokeWidth: 1.9871
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8604 6.90362C15.8604 5.07455 14.3776 3.5918 12.5485 3.5918H11.8862C10.4229 3.5918 9.23669 4.778 9.23669 6.24126V6.24126C9.23669 7.70452 10.4229 8.89072 11.8862 8.89072H15.8604V6.90362Z",
    stroke: "currentColor",
    strokeWidth: 1.9871
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.2627 17.502V24.788C5.2627 27.7145 7.6351 30.0869 10.5616 30.0869H14.801L14.801 17.502H5.2627ZM16.7881 17.502L16.7881 30.0869H21.1595C24.086 30.0869 26.4584 27.7145 26.4584 24.788V17.502H16.7881Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftRounded);
export default __webpack_public_path__ + "static/media/gift-rounded.3e459c23b864bb08de5387e2903948eb.svg";
export { ForwardRef as ReactComponent };